import React, { FC, useCallback } from "react";
import { useSelector } from "react-redux";
import { ColorPicker } from "@evergis/ui";
import { Color } from "@evergis/color";

import { setGrid } from "../../../ducks/print/print";
import { useAction } from "../../../hooks/useAction";
import { getPrintGridColor } from "../../../ducks/print/selectors";

export const GridColorSetting: FC = () => {
  const updateGrid = useAction(setGrid);
  const gridColor = useSelector(getPrintGridColor);
  const setGridColor = useCallback((color: Color) => updateGrid({ color }), [updateGrid]);

  return <ColorPicker value={gridColor} onChange={setGridColor} zIndex={100} />;
};
